import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {  Drawer, Radio, Space } from 'antd';
import FilterInput from "components/Form/filterInput"
import FilterSelect from "components/Form/filterSelect"
import {  useSelector } from 'react-redux';
import { maritalStatusOptions } from 'utils/constants';
import FilterDate from "components/Form/dateFilterInput"
import { Button } from 'components/Button';
import DateInput from 'components/Form/dateInput';

const DocumentsFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    documentType,
    storeType

}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('right');  
   const {
    userData, userDataLoading,
    documentSubType, documentSubTypeLoading,
    costCenter, costCenterLoading
} = useSelector((state) => state.common);


const [userDataOption, setUserDataOption] = useState([]);
const [documentSubTypeOption, setDocumentSubTypeOption] = useState([]);
const [documentTypeOptions, setDocumentTypeOptions] = useState([])
const [costCenterOption, setCostCenterOption] = useState([])

useEffect(()=>{
  let typeOptions = documentType?.map(item=> {return{
    label: item.name,
    value: item.id
    }})
    setDocumentTypeOptions(typeOptions)
},[documentType])
useEffect(()=>{
   
    let _costCenter = costCenter?.map(item=> {
      return{
        label: item.name,
        value: item.id
      }
    })
    setCostCenterOption(_costCenter)
    let _userData = userData?.map(item=> {
        return{
            label: item.first_name+" "+item.last_name,
            value: item.id
        }
    })

    let _documentSubType = documentSubType.map(item=> {
      return{
        label:item.display_name,
        value:item.name
      }
    })
    setUserDataOption(_userData)  
    setDocumentSubTypeOption(_documentSubType)

},[userData, documentSubType, costCenter])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);


  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
      >
      <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("issue_date_after")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "issue_date_after")}} 
        id="search" 
        label={"Issued After"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("issue_date_before")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "issue_date_before")}} 
        id="search" 
        label={"Issued Before"} 
        />
        </div>

      

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("expiry_date_after")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "expiry_date_after")}} 
        id="search" 
        label={"Expiry After"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("expiry_date_before")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "expiry_date_before")}} 
        id="search" 
        label={"Expiry Before"} 
        />
        </div>

     

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "document_type")}} optionLabel={"label"} optionValue={'value'} options={documentTypeOptions} value={setFilterValue("document_type")} placeholder={"Document Type"}/>
        </div>


        {/* <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "document_sub_type")}} optionLabel={"label"} optionValue={'value'} isLoading={documentSubTypeLoading} value={setFilterValue("document_sub_type")} options={documentSubTypeOption}  placeholder={"Document Sub Type"}/>
        </div> */}

        {
          storeType != "store" &&
          <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "company_user")}} optionLabel={"label"} optionValue={'value'}  options={userDataOption} isLoading={userDataLoading}  value={setFilterValue("company_user")} placeholder={"User"}/>
        </div>
        }

        

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "cost_center")}} optionLabel={"label"} optionValue={'value'}  options={costCenterOption} isLoading={costCenterLoading}  value={setFilterValue("cost_center")} placeholder={"Cost Center"}/>
        </div>
      

        <div className="col-12">
          <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>    
     
       </div>

      </Drawer>
    </>
  );
};
export default DocumentsFilterDrawer;